// extracted by mini-css-extract-plugin
module.exports = {"back":"BackButton_back__X_By4"};